import * as React from 'react';
import { useEffect, useState } from 'react';
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import Helper from 'src/support/Helper';

const Action = (props) => {
    let l = 0;
    if (props.CART_DATA_SINGLE !== undefined && props.CART_DATA_SINGLE.scheduleDetails?.length !== undefined) {
        l = props.CART_DATA_SINGLE.scheduleDetails.length;
    }
    return (
        <a onClick={() => {
            store.dispatch(system_notification({
                name: 'QuoteDateSchedulePopup',
                data: {
                    CART_DATA_SINGLE: props.CART_DATA_SINGLE,
                    CART_PRODUCT_DATA: props.CART_PRODUCT_DATA,
                    single_product_inventory: props.single_product_inventory,
                },
            }));
        }}
        > {l > 0 ? 'Edit ' : 'Add '} Schedule Date{l > 0 ? '(s)' : ''}</a>
    )
};

const QuoteQuantityScheduler = (props) => {
    const CART_DATA_SINGLE = props.CART_DATA_SINGLE[1];
    const [asAvailableQuantity, setAsAvailableQuantity] = useState(0);

    useEffect(() => {
        if (CART_DATA_SINGLE && CART_DATA_SINGLE?.scheduleDetails?.length && CART_DATA_SINGLE[`quantity_${CART_DATA_SINGLE.quantity_field_selected}`] !== undefined) {
            let sum = 0;
            CART_DATA_SINGLE.scheduleDetails.forEach(ele => {
                sum += ele.quantity;
            });

            let avlQty = CART_DATA_SINGLE[`quantity_${CART_DATA_SINGLE.quantity_field_selected}`] - sum;
            setAsAvailableQuantity(avlQty)
        }

    }, [CART_DATA_SINGLE]);


    return (
        <>
            {CART_DATA_SINGLE !== undefined && CART_DATA_SINGLE.scheduleDetails !== undefined && CART_DATA_SINGLE.scheduleDetails.length > 0 &&
                <>
                    <div className="mb-3">
                        <span className="font_bold_currency">Scheduled Dates</span>
                        <div className="sceduledate-list border-bottom1 mb-1">
                            {CART_DATA_SINGLE.scheduleDetails.length > 0 &&
                                <>
                                    <div className="d-flex  border-bottom1 justify-content-between">
                                        <div className="col-4 ps-0">Quantity</div>
                                        <div className="col-8 ps-0">Ship Date</div>
                                    </div>

                                    {asAvailableQuantity > 0 ?
                                        <div className="bs5 row m-0">
                                            <div className="col-4 ps-0">{asAvailableQuantity}</div>
                                            <div className="col-8 ps-0">
                                                As Available
                                            </div>
                                        </div> : null}

                                    {CART_DATA_SINGLE.scheduleDetails.map((v, i) => (
                                        <div className="bs5 row m-0" key={i}>
                                            <div className="col-4 ps-0">{v.quantity}</div>
                                            <div className="col-8 ps-0">
                                                {Helper.dateFormatFromString(v.scheduledDate, true)}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </>
            }
            <Action
                CART_DATA_SINGLE={CART_DATA_SINGLE}
                CART_PRODUCT_DATA={props.CART_PRODUCT_DATA}
                single_product_inventory={props.single_product_inventory}
            />
        </>
    );
}

export default QuoteQuantityScheduler;